import styled, { css } from 'styled-components';
import MetaChip from './MetaChip';

const BranchChip = styled(MetaChip)`
  border: 1px solid transparent;
  border-radius: 100px;

  ${({ $readOnly, theme }) =>
    $readOnly &&
    css`
      background: ${theme.colors.disabled};
      color: ${theme.colors.grey3};

      .avatar {
        opacity: 0.6;
      }
    `}
`;

export default BranchChip;
